<template>
  <transition :name="isDroppable ? 'fade' : null">
    <drop-helper v-if="enabled" :dropOptions="dropOptions"></drop-helper>
  </transition>
</template>

<script>
import DropHelper from '@/components/DragDrop/DropHelper';
import { mapGetters, mapState, mapActions } from 'vuex';

export default {
  components: { DropHelper },
  props: ['status'],
  data() {
    return {
      accepts: ['statusContext'],
      savedDragData: null
    };
  },
  watch: {
    enabled: function(n) {
      if (n) {
        console.log('save data');
        //  store the value of dragged data so when drag stops we still have it to execute on
        this.savedDragData = this.draggedData;
      }
    }
  },
  computed: {
    ...mapGetters('components/dragdrop', ['dragging']),
    ...mapState('components/dragdrop', ['draggedData']),
    ...mapGetters('userWorkspaceLite', ['currentUserWorkspaceLite']),
    dropOptions() {
      return {
        accepts: this.accepts,
        zones: [
          {
            id: 'dropMoveNoteBlock',
            show: this.isDroppable,
            targetCursor: true,
            style: {
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 100
            },
            hoverClass: 'q-dropzone-full',
            onDrop: () => this.changeStatus()
          }
        ]
      };
    },
    enabled() {
      const matchedAccepts = this.accepts.filter(value => this.draggedData.types.includes(value));
      return this.dragging && matchedAccepts.length > 0;
    },
    isSameStatus() {
      return this.draggedData.parent.type == this.status;
    },
    isDroppable() {
      //  is this object  a drop, vs a sort item?
      return !this.isSameStatus;
    }
  },
  methods: {
    ...mapActions('context', ['moveQuestionsById', 'updateQuestionType']),
    ...mapActions('userWorkspaceLite', ['updateContextUserStatus']),
    deindent() {
      this.$emit('deindent');
    },
    indent() {
      console.log('indent');
      this.$emit('indent');
    },
    changeStatus() {
      console.log('mpve to folder', this.status);
      const items = this.savedDragData.ids;
      console.log(this.savedDragData);
      items.forEach(i => {
        this.updateContextUserStatus({
          status: this.status,
          userWorkspaceLiteId: this.currentUserWorkspaceLite.id,
          contextId: i
        });
      });
    }
  }
};
</script>

<style>
.q-dropzone-top {
  border-top: 3px solid #2196f3;
}

.q-dropzone-bottom {
  border-bottom: 3px solid #2196f3;
  margin-bottom: -3px;
}
.q-dropzone-full {
  opacity: 0.3;
  background: #2196f3;
}

.zone-move,
.zone-copy {
  background: rgba(250, 250, 250, 0);
  opacity: 0;
}

.list-item:hover .zone-move,
.list-item:hover .zone-copy {
  background: rgba(250, 250, 250, 0.9);
  transition: 0.5s ease all;
  opacity: 1;
}

.list-item:hover .zone-move .drop-zone-content {
  color: #242424;
  border-radius: 2px;
  font-weight: bold;
  background: rgba(255, 255, 255, 0.76);
  transition: 0.5s ease all;
}

.list-item:hover .zone-move.hover-zone-move .drop-zone-content {
  background: #f77797;
}

.list-item:hover .zone-copy .drop-zone-content {
  color: #242424;
  font-weight: bold;
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.76);
  transition: 0.5s ease all;
}

.list-item:hover .zone-copy.hover-zone-copy .drop-zone-content {
  background: #6eeea3;
}

.fade-enter-active {
  transition: opacity 0.5s;
}

.fade-leave-active {
  transition: opacity 0.1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
